export default "__VITE_ASSET__BAZdwuAI__"